import { ValidationProvider } from 'vee-validate'

export default {
  // inject: ['getValue', 'setValue'],
  inject: {
    injectedGetValue: {
      from: 'getValue',
      default() {
        return undefined
      },
    },
    injectedSetValue: {
      from: 'setValue',
      default() {
        return undefined
      },
    },
    injectedCheckDependents:{
      from: 'checkDependents',
      default() {
        return undefined
      }
    },
    injectedIsAdmin:{
      from: 'isAdmin',
      default() {
        return undefined
      }
    },
    injectedIsSuperAdmin:{
      from: 'isSuperAdmin',
      default() {
        return undefined
      }
    },
    injectedFieldLoaded:{
      from: 'fieldLoaded',
      default() {
        return undefined
      }
    },
    injectedFieldChanged:{
      from: 'fieldChanged',
      default() {
        return undefined
      }
    }
  },
  components: {
    ValidationProvider,
  },
  data: () => {
    return {
      shouldShow:false,
    }
  },
  props: {
    // sometimes used for v-if ing things that are similar
    id: {
      type: Number,
      required: false,
    },
    fieldAssignmentId: {
      type: Number | String,
      required: false,
    },
    type: {
      type: String,
      required: false,
    },
    type_attributes: {
      type: String,
      required: false,
      default:'',
    },
    name: {
      type: String,
      required: false,
      default:'',
    },
    label: {
      type: String,
      required: false,
      default:'',
    },
    directions: {
      type: String,
      required: false,
      default:'',
    },
    default_value: {
      type: String,
      required: false,
      default:'',
    },
    // vuetify component props
    componentProps: {
      type: Object,
      required: false,
      default: () => {},
    },
    // for advanced items with multiple components
    extraProps: {
      type: Object,
      required: false,
      default: () => {},
    },
    settings: {
      type: Object|Array,
      default: () => {},
    },
    // validation arguments to drive vee-validate (we can customize/control names)
    validation_settings: {
      type: Object,
      required: false,
      default: () => {},
    },
    // for v-model if not using schema renderer
    value: {
      type: null,
      required: false,
    },
    value_options: {
      type: Array,
      default: () => [],
    },
    // key name used to access values from outside
    field_path: {
      required: false,
    },
    placeholder: {
      required: false,
    },
    // hides the * on required fields
    hideRequired: {
      required: false,
      type: Boolean,
      default: false,
    },
    // validation provider props
    providerProps: {
      required: false,
      type: Object,
    },
  },
  computed: {
    // merge component props with default component settings (component defaults will override supplied props)
    vProps() {
      return { ...this.settings, ...this.providerProps, ...this.componentProps, ...this.defaults }
    },
    innerLabel() {
      if (this.hideRequired || this.componentProps?.hideRequired)
        return this.label;

      return this.label?.length > 0 && this.validation_settings.required
          ? `<div class="d-flex flex-fill"><div>${this.label}</div><div><span class="red--text ml-2"><strong>*</strong></span></div>`
          : this.label;
    },
    innerValue: {
      get() {
        let value = this.value;
        if (this.injectedGetValue !== undefined && this.field_path) {
          value = this.injectedGetValue(this.field_path)
        }
        return value || this.default_value;
      },
      set(v) {
        if (this.injectedSetValue !== undefined && this.field_path) {
          this.injectedSetValue(this.field_path, v)
        } else {
          this.$emit('input', v);
        }
        setTimeout(() =>{
          this.checkDependents();
        }, 500);
      },
    },
    innerIsAdmin() {
      return this.injectedIsAdmin !== undefined ? this.injectedIsAdmin() : false;
    },
    innerIsSuperAdmin() {
      return this.injectedIsSuperAdmin !== undefined ? this.injectedIsSuperAdmin() : false;
    },
    innerShouldShow() {
      return !this.validation_settings || !this.validation_settings.originallyHidden || !!this.shouldShow;
    },
    innerDisabled() {
      return this.type_attributes.indexOf('Disabled') > -1;
    },
    innerIsReview() {
      return this.type_attributes.indexOf('Review') > -1;
    },
    enableValidation(){
      return !this.vProps.readonly || !this.vProps.disabled
    }
  },
  watch: {
      innerValue: {
        deep:true,
        handler() {
          this.$nextTick(() => {
            this.fieldChanged();
          })
        }
      }
  },
  mounted() {
    this.$root.$on('fieldChanged', data => {
      const {field, attribute, value} = data;
      // make sure the event is for this field
      if( field.id === this.id && field.fieldAssignmentId === this.fieldAssignmentId ) {
        this[attribute] = value;
      }
    });

    setTimeout(() => {
        this.checkDependents(); // see if we need to show hidden fields
    }, 500);
  },
  methods:{
    goToPage(pageNumber) {
      this.$emit('goToPage', pageNumber);
    },
    checkDependents() {
      if( this.injectedCheckDependents !== undefined ) {
        return this.injectedCheckDependents(this.fieldAssignmentId, this.innerValue);
      }
      return null;
    },
    setSiblingValue(fieldPath, value) {
      if (this.injectedSetValue !== undefined) {
        this.injectedSetValue(fieldPath, value)
        this.checkDependents();
      }
    },
    getSiblingValue(fieldPath) {
      if (this.injectedGetValue !== undefined) {
        return this.injectedGetValue(fieldPath)
      }
    },
    fieldLoaded() {
      if (this.injectedFieldLoaded !== undefined) {
        return this.injectedFieldLoaded(this.fieldAssignmentId)
      }
    },
    fieldChanged() {
      this.$nextTick(() => {
        if (this.injectedFieldChanged !== undefined) {
          return this.injectedFieldChanged(this.fieldAssignmentId, this.innerValue)
        }
      })
    }
  }
}
